import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getGates, updateGate, createGate } from '../api/gates';
import { Gate } from '../types/Gate';

export const useGates = (queryString: string = '') =>
  useQuery({
    queryKey: ['gates', queryString],
    queryFn: () => getGates(queryString),
  });

export const useGatesWMinRoute = () =>
  useQuery({
    queryKey: ['gates', 'minimal_route'],
    queryFn: () => getGates('scope=minimal_route'),
  });

export const useUpdateGate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ gateId, data }: { gateId: string; data: Partial<Gate> }) =>
      updateGate(gateId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gates'] });
    },
  });
};

export const useCreateGate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Gate>) => createGate(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gates'] });
    },
  });
};
